import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {ContentType, request} from 'utils/request';

type PostCreateCreditCardView = UseMutationResult<
    Api.Response.Success<{mid: string}>,
    Api.Response.Failure<{message: string}>,
    {ccToken: string; mrToken: string}
>;

export const usePostCreateCreditCardView = (): PostCreateCreditCardView => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({ccToken, mrToken}) =>
            request({
                contentType: ContentType.JSON,
                formData: {cc_token: ccToken},
                locale,
                method: 'POST',
                uri: window.Urls.create_credit_card_charge_view(mrToken),
            }),
    });
};

type GetCreditCardChargeView = UseMutationResult<
    Api.Response.Success<{reason: string; state: string}>,
    Api.Response.Failure<{message: string}>,
    {mid: string}
>;

export const useGetCreditCardChargeView = (): GetCreditCardChargeView => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({mid}) =>
            request({
                contentType: ContentType.JSON,
                locale,
                method: 'GET',
                uri: window.Urls.cc_charge_view(mid),
            }),
    });
};

type CreateCheckoutSessionView = UseMutationResult<
    Api.Response.Success<{clientSecret: string}>,
    Api.Response.Failure<{message: string}>,
    {mrToken: string; palLink: string}
>;

export const usePostCreateCheckoutSessionView =
    (): CreateCheckoutSessionView => {
        const locale = useLocale();

        return useMutation({
            mutationFn: ({mrToken, palLink}) =>
                request({
                    contentType: ContentType.JSON,
                    formData: {mr_token: mrToken, pal_link: palLink},
                    locale,
                    method: 'POST',
                    uri: window.Urls.create_checkout_session_view(mrToken),
                }),
        });
    };

type GetMoneyRequestIsPaidView = UseMutationResult<
    Api.Response.Success<{paid: boolean}>,
    Api.Response.Failure<{message: string}>,
    {mrMid: string}
>;

export const useGetMoneyRequestIsPaidView = (): GetMoneyRequestIsPaidView => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({mrMid}) =>
            request({
                contentType: ContentType.JSON,
                locale,
                method: 'GET',
                uri: window.Urls.money_request_is_paid_view(mrMid),
            }),
    });
};
